import axios from 'axios'
import commonUrl from '../common/js/commonUrl.js'

// 业主大会会议公告：按分组码 code 取回该组的全部公告（data[0] 为主公告 type=1，其余为次级公告 type=2）
export function getMeetingAnnouncementList (code) {
  // 临时用后端测试接口：正式接口 home/meeting_announcement/index 目前未发布到 zzwx 环境（访问返回 404）
  // 后端发布后改回：`${commonUrl.apihost}index.php/home/meeting_announcement/index?code=${code}`
  const url = `${commonUrl.apihost}index.php/home/meeting_announcement/index?code=${code}`
  return axios({
    method: 'GET',
    url: url
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/api/meetingAnnouncement.js